module.exports = __webpack_public_path__ + "img/企业介绍banner.9dde1e24.jpg";